import RouteContainer from 'containers/RouteContainer';
import Component from './containers/ProfileContainer';

export const path = `${DOCUMENTS_PATH}/profile`;
export const navigation = { name: 'profile', id: 'profile.title', nonNavigable: true };

export default RouteContainer(path, Component);
